import { Injectable } from '@angular/core';
import { BrokerAuditDeclarationService } from './broker-audit-declaration.service';
import { WorkflowModel } from '../../model/workflowModel';
import { BrokerAuditDataModel } from '../../model/brokerAuditDataModel';
import { SubmitBrokerAuditDataRequestModel } from '../../model/submitBrokerAuditDataRequestModel';
import { Subscription } from 'rxjs';
import { MessageModel } from '../../model/models';
import { SubmitBrokerAuditDataResponseModel } from '../../model/submitBrokerAuditDataResponseModel';
import { CurrentPageWatcherService } from '../../shared/utils/CurrentPageWatcher';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { BadQuestionnaireModel } from '../../model/badQuestionnaireModel';
import { StorageService } from '../../shared/security/StorageService';
import { StartFunctionResponseModel } from '../../model/startFunctionResponseModel';
import { SubmitBrokerAuditQuestionnaireRequestModel } from '../../model/submitBrokerAuditQuestionnaireRequestModel';

@Injectable()
export class BrokerAuditDeclarationSaveDataService {
  
  workflow: WorkflowModel = new WorkflowModel();
  brokerAuditDataModel: BrokerAuditDataModel = new BrokerAuditDataModel();
  badQuestionnaireDataModel: BadQuestionnaireModel = new BadQuestionnaireModel();
  submitBrokerAuditQuestionnaireRequestModel: SubmitBrokerAuditQuestionnaireRequestModel = new SubmitBrokerAuditQuestionnaireRequestModel();

  lastUpdated: Date;

  userMessages: Array<MessageModel> = [];
  
  startFunction: StartFunctionResponseModel;

  constructor(private router: Router, 
              private currentPageWatcher: CurrentPageWatcherService, 
              private brokerAuditDeclarationService: BrokerAuditDeclarationService,
              private storageService : StorageService) { }

  saveBAD(submitBrokerAuditDataRequestModel){
    
    this.workflow  =this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel;
    
    this.setBrokerAuditDataModel();

    this.brokerAuditDeclarationService.submitBrokerAuditDeclarationData(submitBrokerAuditDataRequestModel)
      .subscribe((response: SubmitBrokerAuditDataResponseModel) => {
        this.brokerAuditDeclarationService.getNotifySaveData().emit(false);
        
        console.log("submitBrokerAuditDeclarationData response = ", response);
        response.UserMessages.forEach(msg => {
          this.userMessages.push(msg);
        })
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        if (response.Summary == 0) {
          this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel = response.Workflow;
          //get bad updated data
          this.brokerAuditDeclarationService.getBrokerAuditDeclarationData(this.workflow.WorkflowID).subscribe(
            (badData: BrokerAuditDataModel) => {
              this.brokerAuditDataModel = badData;
              this.brokerAuditDeclarationService.brokerAuditDataModel = this.brokerAuditDataModel;
              this.brokerAuditDeclarationService.getNotifyBrokerAuditLastUpdated().emit(this.brokerAuditDataModel.LastUpdated);
      
            },
            );
         
          this.userMessages = [];
        }
        if (response.Summary == 1) {
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];

        }

        if (response.Summary == 2) {
          this.currentPageWatcher.displayUserMessage = true;
          this.router.navigate(["/home"]);
          this.userMessages = [];
        }
      })
  }

  setBrokerAuditDataModel(){
    this.brokerAuditDataModel = this.brokerAuditDeclarationService.brokerAuditDataModel;

    this.brokerAuditDataModel.GeneralTrustAccounts=this.brokerAuditDataModel.GeneralTrustAccounts.filter(el=>el.Title!="" && el.AccountNumber!="" && el.FinancialInstitutionName!="" && el.FinanialInstitutionAddress!="");
    this.brokerAuditDataModel.PropertyManagementTrustAccounts=this.brokerAuditDataModel.PropertyManagementTrustAccounts.filter(el=>el.Title!="" && el.AccountNumber!="" && el.FinancialInstitutionName!="" && el.FinanialInstitutionAddress!="");
    this.brokerAuditDataModel.OffSiteStorageLocations = this.brokerAuditDataModel.OffSiteStorageLocations.filter(el=>el.FacilityAddress!="" && el.FacilityName!="");
    this.brokerAuditDataModel.TransactionManagementSystems = this.brokerAuditDataModel.TransactionManagementSystems.filter(el=>el.DatesUsed!="" && el.ProviderAddress!="" && el.SystemName!="");
    this.brokerAuditDataModel.PropertyManagementAccountingSystems = this.brokerAuditDataModel.PropertyManagementAccountingSystems.filter(el=>el.DatesUsed!="" && el.ProviderAddress!="" && el.SystemName!="");
    this.brokerAuditDataModel.BrokerOwnedElectronicStorageSystems = this.brokerAuditDataModel.BrokerOwnedElectronicStorageSystems.filter(el=>el.Location!="" && el.StorageType!="" );
    this.brokerAuditDataModel.NotBrokerOwnedElectronicStorageSystems = this.brokerAuditDataModel.NotBrokerOwnedElectronicStorageSystems.filter(el=>el.SystemName!="" && el.VendorContact!="" );
  }


  submitBADQuestionnaire() {
    this.startFunction = this.storageService.getStartFunctionData();

    this.workflow = this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel;
    this.badQuestionnaireDataModel = this.brokerAuditDeclarationService.badQuestionnaireDataModel;

    this.submitBrokerAuditQuestionnaireRequestModel.WorkflowID = this.workflow.WorkflowID;
    this.submitBrokerAuditQuestionnaireRequestModel.CurrentStepIndex = this.workflow.CurrentStepIndex;
    this.submitBrokerAuditQuestionnaireRequestModel.Answers = this.brokerAuditDeclarationService.badQuestionnaireDataModel.Answers;
    this.submitBrokerAuditQuestionnaireRequestModel.SubmitAsDraft = true;
    this.submitBrokerAuditQuestionnaireRequestModel.AdditionalInformationComments = this.badQuestionnaireDataModel.AdditionalInformationComments;

      this.brokerAuditDeclarationService.submitBrokerAuditDeclarationQuestionnaire(this.submitBrokerAuditQuestionnaireRequestModel)
      .subscribe(response => {
        console.log("submitBrokerAuditDeclarationQuestionnaire response : ", response);
        response.UserMessages.forEach(msg => {
          this.userMessages.push(msg);
        })
        this.currentPageWatcher.sendUserMessages(this.userMessages);

        if (response.Summary == 0) {
          //update BAD workflow informations (brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel is shared)
          this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel = response.Workflow;
          //save startFunction with updated workflow in localstorage
          this.brokerAuditDeclarationService.updateStartFunction(this.startFunction);

          //get bad questionnaire updated data
          this.brokerAuditDeclarationService.getBrokerAuditDeclarationQuestionnaire(this.workflow.WorkflowID).subscribe(
            (badQuestData: BadQuestionnaireModel) => {
              this.badQuestionnaireDataModel = badQuestData;
              this.brokerAuditDeclarationService.badQuestionnaireDataModel = this.badQuestionnaireDataModel;
              this.brokerAuditDeclarationService.getNotifyBrokerAuditLastUpdatedQuestionnaire().emit(this.badQuestionnaireDataModel.LastUpdated);
            });
          this.userMessages = [];
        }
        if (response.Summary == 1) {
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];

        }

        if (response.Summary == 2) {
          this.currentPageWatcher.displayUserMessage = true;
          this.router.navigate(["/home"]);
          this.userMessages = [];
        }
      },
        err => {
          console.log("error: ", err);
        });
    
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/broker-audit-declaration/broker-audit-declaration-save-data.service.ts